export default __webpack_public_path__ + "static/listening-music-5a00cf7e9b8b853c469fd46fc064527c.jpg";